/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateContainerCommand } from '../../models/create-container-command';
import { CreateContainerCommandResult } from '../../models/create-container-command-result';

export interface ApiContainersCreateContainerPost$Plain$Params {
      body?: CreateContainerCommand
}

export function apiContainersCreateContainerPost$Plain(http: HttpClient, rootUrl: string, params?: ApiContainersCreateContainerPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContainerCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersCreateContainerPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateContainerCommandResult>;
    })
  );
}

apiContainersCreateContainerPost$Plain.PATH = '/api/Containers/CreateContainer';
